import OrderList from "../../components/order/OrderList";
import NavLinksAdmin from "../../components/navlinksAdmin/NavLinksAdmin";

const AdminOrderList = () => {
  return (
    <div className="inside-page-container-blk">
      <div className="admin-page-main-container">
        <NavLinksAdmin />
        <div>
          <OrderList />
        </div>
      </div>
    </div>
  );
};

export default AdminOrderList;
